import { useTranslation } from 'react-i18next';

import { Card, CardContent, Typography } from '@mui/joy';

import { DroneHeartBeat } from '../../models/DroneProfile/DroneProfile.model';

interface Props {
  heartbeat: DroneHeartBeat;
}

export default function PacketStatsTable({ heartbeat}: Props) {
  const { t } = useTranslation();
  const stats = heartbeat.packet_statistics;

  if (!stats || Object.keys(stats).length === 0) return null;

  return (
    <Card color="neutral" variant="soft">
      <CardContent>
        <Typography gutterBottom level="title-md">
          {t('heartbeat.packet_stats.title')}
        </Typography>

        <div className="overflow-x-auto mt-4">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">
                  {t('heartbeat.packet_stats.interface')}
                </th>
                <th className="px-6 py-3 text-right font-medium text-gray-500 uppercase tracking-wider">
                  {t('heartbeat.packet_stats.rx_packets')}
                </th>
                <th className="px-6 py-3 text-right font-medium text-gray-500 uppercase tracking-wider">
                  {t('heartbeat.packet_stats.tx_packets')}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {Object.entries(stats).map(([iface, values], idx) => (
                <tr
                  className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                  key={`pkt-${idx}`}
                >
                  <td className="px-6 py-2 font-medium text-gray-900">{iface}</td>
                  <td className="px-6 py-2 text-right text-gray-600">
                    {values.rx?.toLocaleString() ?? 'N/A'}
                  </td>
                  <td className="px-6 py-2 text-right text-gray-600">
                    {values.tx?.toLocaleString() ?? 'N/A'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
